export default __webpack_public_path__ + "static/media/make8.c326f007.png";